export default "dist/6768c1976c2ad78da1634b00b1e84dc2.png";